var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlueArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 65,
    viewBox: "0 0 66 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.8376 0.949682L65.0541 30.2841C65.4045 30.6358 65.6497 30.9876 65.7898 31.3393C65.9299 31.691 66 32.0779 66 32.5C66 32.9221 65.9299 33.309 65.7898 33.6607C65.6497 34.0125 65.4045 34.3642 65.0541 34.7159L35.7325 64.1558C35.172 64.7186 34.4713 65 33.6306 65C32.7898 65 32.0541 64.6834 31.4236 64.0503C30.793 63.4172 30.4777 62.6786 30.4777 61.8344C30.4777 60.9903 30.793 60.2516 31.4236 59.6185L55.2803 35.6656L3.15286 35.6656C2.24203 35.6656 1.48885 35.3666 0.893313 34.7687C0.29777 34.1707 -4.8681e-06 33.4145 -4.78815e-06 32.5C-4.70821e-06 31.5855 0.297771 30.8293 0.893314 30.2313C1.48885 29.6334 2.24203 29.3344 3.15286 29.3344L55.2803 29.3344L31.3185 5.27598C30.758 4.71321 30.4777 4.00975 30.4777 3.16559C30.4777 2.32143 30.793 1.5828 31.4236 0.949681C32.0541 0.316563 32.7898 4.72607e-06 33.6306 4.79957e-06C34.4713 4.87307e-06 35.207 0.316564 35.8376 0.949682Z",
    fill: "#00A9E2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueArrowRight);
export default __webpack_public_path__ + "static/media/blue-arrow-right.d72de88c62fa12709c0c2b2bbec8fa23.svg";
export { ForwardRef as ReactComponent };